import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class GeneralInfoResource extends BaseCamelCasedResource {
    pk() {
        return `${this.productId}`;
    }
}
GeneralInfoResource.urlRoot = legacyApiResourceUrl("Product/GetGeneralInfo");
export { GeneralInfoResource };
//# sourceMappingURL=GeneralInfoResource.js.map